var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_25507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5L8.75 20.5V16.75H20V14.25H8.75V10.5L2.5 15.5Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2511 4.2487C14.7731 4.2446 13.3088 4.53384 11.9433 5.09965C10.5778 5.66547 9.33815 6.49662 8.29614 7.54495L10.0636 9.31245C11.7161 7.65995 13.9136 6.7487 16.2511 6.7487C18.5886 6.7487 20.7861 7.65995 22.4386 9.31245C24.0911 10.965 25.0024 13.1625 25.0024 15.5C25.0024 17.8375 24.0911 20.035 22.4386 21.6875C20.7861 23.34 18.5886 24.2512 16.2511 24.2512C13.9136 24.2512 11.7161 23.34 10.0636 21.6875L8.29614 23.455C10.4199 25.58 13.2449 26.7512 16.2511 26.7512C19.2574 26.7512 22.0824 25.58 24.2061 23.455C26.3311 21.3312 27.5024 18.5062 27.5024 15.5C27.5024 12.4937 26.3311 9.6687 24.2061 7.54495C23.1641 6.49662 21.9245 5.66547 20.559 5.09965C19.1934 4.53384 17.7292 4.2446 16.2511 4.2487Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_25507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b584d6ad4fbe81495989107be4a6f076.svg";
export { ForwardRef as ReactComponent };